module.exports = __webpack_public_path__ + "media/site/images/case_studies/ekanban/screen-macbook-casestudy-2a1593aee0c5d8b6b42342029a9def2a.png";